module.exports = __webpack_public_path__ + "static/car-pc/img/location.79b42253.svg";